<template>
  <div class="pricing">

    <img :src="getIconUrl(`${title == 'Premium' ? 'wallet' : 'pocket-knief'}.png`)" alt="" class="pack-icon">
    
    <span class="title">{{title}}</span>
    <div class="price">
      <span>{{ price }} DT</span>
    </div>
    <div class="pack-content" v-for="item in data" :key="item.name">
      <span class="content">
        <!--
        <img src="../../assets/icons/bubble.png">
        -->
        <v-icon small>
          {{ item.value ? "mdi-progress-check" : "mdi-close" }}
        </v-icon>
        {{ item.label }}
        <span class="value" v-if="typeof item.value === 'string' || typeof item.value === 'number'">
          {{ item.value }}
        </span>
      </span>
    </div>
    <div class="commande">
      <v-btn
        dark
        block
        rounded
        :disabled="disabled"
        :color="color"
        :loading="loading"
        @click="$emit('order-coach-clicked',packId)"
        >
        Commander
        </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import coachMixins from "@/mixins/coachMixins";

export default {
  mixins: ["coachMixins"],
  props: {
    data: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    packId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    price: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["loading", "isLoggedIn", "user"]),
    showOrigin() {
      return `${window.location.origin}${this.$route.path}`;
    },
  },
  methods: {
    ...mapActions(["checkIn", "createOrder"]),
    async doCheckIn(payload) {
      if (this.isLoggedIn) {
        const link = await this.createOrder(payload);
        if (link) window.location = link;
        console.log("link", link);
      } else this.pushLoginForm();
    },
    getIconUrl(img){
        return require('../../assets/icons/'+img)
    }
  },
};
</script>

<style scoped>
.pricing{
    max-width: 100%;
    width: 205px;
    height: max-content;
    border-radius: 6px;
    background: #fff;
    box-shadow: 0px 50px 70px rgba(95, 61, 196, 0.2);
    padding: 30px;
}
.pack-icon{
    max-width: 100%;
    width: 100px;
    height: 100px;
    display: block;
    margin: auto;
    object-fit: contain;
}
.title{
    font-weight: bold;
    text-align: center;
    color: #343a40;
    margin: auto;
    display: block;
    margin-top: 20px;
}
.price{
  text-align: center;
}
.price span{
    font-weight: bold;
    font-size: 38px;
    text-align: center;
    color: #E91E24;
    margin-bottom: 15px;
    display: block;
}
.pack-content{
    text-align: left;
}
.pack-content .content{
    display: flex;
    width: 100%;
    font-weight: 500;
    font-size: 12px;
    text-align: left;
    color: #343a40;
    margin-bottom: 10px;
}
.pack-content img{
    max-width: 100%;
    width: 15px;
    display: block;
    margin-right: 10px;
}
.commande{
    margin-top: 30px;
}
.commande .v-btn{
    box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15);
    padding: 20px;
}
.v-icon{
    font-size: 16px;
    margin-right: 5px;
}
.mdi-progress-check{
  color: #2ed573;
}
.mdi-close{
  color: #ff4757;
}
.value{
    font-weight: 600;
    margin-left: 5px;
}
.theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined){
    box-shadow: none;
    padding: 0;
    height: 0;
}
</style>